module.exports = __webpack_public_path__ + "img/imtoken1.691c6d55.png";